import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const EndOfDayTools = ({ className = '' }) => {
  const [selectedItems, setSelectedItems] = useState([]);
  const [conversionMode, setConversionMode] = useState('charity');

  const unsoldItems = [
  {
    id: 1,
    title: "Pan Artesanal Variado",
    originalPrice: 180,
    quantity: 4,
    category: "Panadería",
    expiresIn: "2 horas",
    image: "https://images.unsplash.com/photo-1732361551253-52d03322869b",
    imageAlt: "Assorted artisanal bread loaves with golden crust on wooden display"
  },
  {
    id: 2,
    title: "Postres del Día",
    originalPrice: 120,
    quantity: 3,
    category: "Postres",
    expiresIn: "4 horas",
    image: "https://images.unsplash.com/photo-1734935908960-778d7febd646",
    imageAlt: "Colorful assorted desserts including cakes and pastries in display case"
  },
  {
    id: 3,
    title: "Ensaladas Frescas",
    originalPrice: 90,
    quantity: 2,
    category: "Saludable",
    expiresIn: "1 hora",
    image: "https://images.unsplash.com/photo-1621087859068-6b7c409e3b80",
    imageAlt: "Fresh mixed green salads with vegetables in clear containers"
  }];


  const charityPartners = [
  { value: 'caritas', label: 'Cáritas Diocesana' },
  { value: 'banco-alimentos', label: 'Banco de Alimentos' },
  { value: 'cruz-roja', label: 'Cruz Roja Española' },
  { value: 'comedores-sociales', label: 'Comedores Sociales Locales' }];


  const conversionOptions = [
  { value: 'charity', label: 'Donación a Caridad' },
  { value: 'discount', label: 'Descuento Adicional' },
  { value: 'compost', label: 'Compostaje' }];


  const [selectedCharity, setSelectedCharity] = useState('');

  const handleItemSelect = (itemId) => {
    setSelectedItems((prev) =>
    prev?.includes(itemId) ?
    prev?.filter((id) => id !== itemId) :
    [...prev, itemId]
    );
  };

  const handleSelectAll = () => {
    if (selectedItems?.length === unsoldItems?.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(unsoldItems?.map((item) => item?.id));
    }
  };

  const calculateCharityValue = () => {
    const selectedItemsData = unsoldItems?.filter((item) => selectedItems?.includes(item?.id));
    return selectedItemsData?.reduce((total, item) => total + item?.originalPrice * item?.quantity * 0.3, 0);
  };

  const calculateDiscountValue = () => {
    const selectedItemsData = unsoldItems?.filter((item) => selectedItems?.includes(item?.id));
    return selectedItemsData?.reduce((total, item) => total + item?.originalPrice * item?.quantity * 0.25, 0);
  };

  const handleConversion = () => {
    const selectedItemsData = unsoldItems?.filter((item) => selectedItems?.includes(item?.id));

    console.log('Converting items:', {
      mode: conversionMode,
      items: selectedItemsData,
      charity: selectedCharity,
      value: conversionMode === 'charity' ? calculateCharityValue() : calculateDiscountValue()
    });

    // Reset selection
    setSelectedItems([]);
  };

  const getUrgencyColor = (expiresIn) => {
    const hours = parseInt(expiresIn);
    if (hours <= 1) return 'text-error';
    if (hours <= 2) return 'text-warning';
    return 'text-muted-foreground';
  };

  return (
    <div className={`bg-card border border-border rounded-lg p-6 ${className}`}>
      <div className="flex items-center justify-between mb-6">
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Herramientas de Fin de Día
          </h2>
          <p className="text-sm text-muted-foreground mt-1">
            Gestiona el inventario no vendido de manera sostenible
          </p>
        </div>
        
        <div className="flex items-center space-x-2">
          <Icon name="Clock" size={20} color="var(--color-warning)" />
          <span className="text-sm font-medium text-warning">
            {unsoldItems?.length} productos por expirar
          </span>
        </div>
      </div>
      {/* Conversion Mode Selection */}
      <div className="mb-6">
        <label className="block text-sm font-medium text-foreground mb-3">
          Modo de Conversión
        </label>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
          {conversionOptions?.map((option) =>
          <button
            key={option?.value}
            onClick={() => setConversionMode(option?.value)}
            className={`p-4 rounded-lg border text-left transition-all ${
            conversionMode === option?.value ?
            'border-primary bg-primary/5 text-primary' : 'border-border hover:border-primary/50 text-foreground'}`
            }>

              <div className="flex items-center space-x-2 mb-2">
                <Icon
                name={
                option?.value === 'charity' ? 'Heart' :
                option?.value === 'discount' ? 'Percent' : 'Recycle'
                }
                size={18} />

                <span className="font-medium text-sm">{option?.label}</span>
              </div>
              <p className="text-xs text-muted-foreground">
                {option?.value === 'charity' && 'Dona a organizaciones benéficas'}
                {option?.value === 'discount' && 'Aplica descuentos adicionales'}
                {option?.value === 'compost' && 'Envía a compostaje sostenible'}
              </p>
            </button>
          )}
        </div>
      </div>
      {/* Charity Selection (if charity mode) */}
      {conversionMode === 'charity' &&
      <div className="mb-6">
          <Select
          label="Seleccionar Organización Benéfica"
          options={charityPartners}
          value={selectedCharity}
          onChange={setSelectedCharity}
          placeholder="Elige una organización"
          description="Las donaciones son deducibles de impuestos" />

        </div>
      }
      {/* Unsold Items List */}
      <div className="mb-6">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-lg font-heading font-semibold text-foreground">
            Productos No Vendidos
          </h3>
          <div className="flex items-center space-x-2">
            <input
              type="checkbox"
              checked={selectedItems?.length === unsoldItems?.length && unsoldItems?.length > 0}
              onChange={handleSelectAll}
              className="rounded border-border" />

            <span className="text-sm text-muted-foreground">
              Seleccionar todos
            </span>
          </div>
        </div>

        <div className="space-y-3">
          {unsoldItems?.map((item) =>
          <div
            key={item?.id}
            className={`flex items-center space-x-4 p-4 rounded-lg border transition-all ${
            selectedItems?.includes(item?.id) ?
            'border-primary bg-primary/5' : 'border-border hover:border-primary/30'}`
            }>

              <input
              type="checkbox"
              checked={selectedItems?.includes(item?.id)}
              onChange={() => handleItemSelect(item?.id)}
              className="rounded border-border" />

              
              <div className="w-16 h-16 rounded-lg overflow-hidden bg-muted flex-shrink-0">
                <img
                src={item?.image}
                alt={item?.imageAlt}
                className="w-full h-full object-cover"
                onError={(e) => {
                  e.target.src = 'publicpublic/assets/images/slazzer-preview-av4u0-1762512006110.png';
                }} />

              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-foreground truncate">
                  {item?.title}
                </h4>
                <div className="flex items-center space-x-4 mt-1">
                  <span className="text-sm text-muted-foreground">
                    {item?.category}
                  </span>
                  <span className="text-sm text-muted-foreground">
                    Cantidad: {item?.quantity}
                  </span>
                  <span className="text-sm font-medium text-foreground">
                    ${item?.originalPrice} c/u
                  </span>
                </div>
              </div>
              
              <div className="text-right flex-shrink-0">
                <div className={`text-sm font-medium ${getUrgencyColor(item?.expiresIn)}`}>
                  Expira en {item?.expiresIn}
                </div>
                <div className="text-xs text-muted-foreground mt-1">
                  Valor total: ${item?.originalPrice * item?.quantity}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Conversion Summary */}
      {selectedItems?.length > 0 &&
      <div className="bg-muted/30 rounded-lg p-4 mb-6">
          <h4 className="font-medium text-foreground mb-3">
            Resumen de Conversión
          </h4>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">
                {selectedItems?.length}
              </div>
              <div className="text-sm text-muted-foreground">
                Productos seleccionados
              </div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl font-bold text-foreground">
                ${conversionMode === 'charity' ? calculateCharityValue() : calculateDiscountValue()}
              </div>
              <div className="text-sm text-muted-foreground">
                {conversionMode === 'charity' ? 'Valor de donación' : 'Precio con descuento'}
              </div>
            </div>
            
            <div className="text-center">
              <div className="text-2xl font-bold text-success">
                {conversionMode === 'charity' ? '100%' : '75%'}
              </div>
              <div className="text-sm text-muted-foreground">
                Desperdicio evitado
              </div>
            </div>
          </div>
        </div>
      }
      {/* Action Buttons */}
      <div className="flex items-center justify-between">
        <div className="text-sm text-muted-foreground">
          {conversionMode === 'charity' &&
          <div className="flex items-center space-x-1">
              <Icon name="Info" size={14} />
              <span>Las donaciones generan certificado fiscal</span>
            </div>
          }
          {conversionMode === 'discount' &&
          <div className="flex items-center space-x-1">
              <Icon name="Info" size={14} />
              <span>Descuento adicional del 25% aplicado</span>
            </div>
          }
          {conversionMode === 'compost' &&
          <div className="flex items-center space-x-1">
              <Icon name="Info" size={14} />
              <span>Contribuye a la economía circular</span>
            </div>
          }
        </div>
        
        <div className="flex items-center space-x-3">
          <Button
            variant="outline"
            onClick={() => setSelectedItems([])}
            disabled={selectedItems?.length === 0}>

            Limpiar Selección
          </Button>
          
          <Button
            variant="default"
            onClick={handleConversion}
            disabled={selectedItems?.length === 0 || conversionMode === 'charity' && !selectedCharity}>

            <Icon
              name={
              conversionMode === 'charity' ? 'Heart' :
              conversionMode === 'discount' ? 'Percent' : 'Recycle'
              }
              size={16}
              className="mr-2" />

            {conversionMode === 'charity' && 'Donar Productos'}
            {conversionMode === 'discount' && 'Aplicar Descuento'}
            {conversionMode === 'compost' && 'Enviar a Compostaje'}
          </Button>
        </div>
      </div>
    </div>);

};

export default EndOfDayTools;